import { fmt, fmtMoney, fmtDate, logoUrl } from "@/lib/api";
import { useSettings } from "@/hooks/useSettings";

export const PurchaseReceipt = ({ purchase: p }) => {
  const { logoV, settings } = useSettings();
  return (
    <div id="receipt" className="mx-auto w-full max-w-[300px] bg-white p-4 font-mono text-[12px] leading-tight text-black" data-testid="purchase-receipt">
      <div className="text-center">
        {logoV && <img src={logoUrl(logoV)} alt="logo" className="mx-auto mb-1 max-h-16 object-contain" />}
        <p className="text-base font-bold uppercase">{settings.company_name}</p>{settings.address && <p>{settings.address}</p>}
        <p>{p.warehouse_name}</p>
        {settings.phone && <p>Tél : {settings.phone}</p>}
        <p className="my-1">--------------------------------</p>
        <p className="font-bold">FACTURE D'ACHAT {p.number}</p>
        <p>{fmtDate(p.created_at)}</p>
        <p>Date facture : {(p.date || "").slice(0, 10).split("-").reverse().join("/")}</p>
        <p>Saisie par : {p.user_name}</p>
        <p className="my-1">--------------------------------</p>
      </div>
      <p className="font-semibold">Fournisseur : {p.supplier_name}</p>
      {p.reference && <p>N° facture fournisseur : {p.reference}</p>}
      {p.stock_doc_number && <p>Bon d'entrée lié : {p.stock_doc_number}</p>}
      {p.note && <p>Note : {p.note}</p>}
      {p.lines?.length > 0 && <>
        <p className="my-1 text-center">--------------------------------</p>
        {p.lines.map((l, i) => <div key={i} className="mb-1"><p className="font-semibold">{l.reference && <span className="mr-1 text-[10px]">{l.reference}</span>}{l.fabric_name}</p><div className="flex justify-between"><span>{fmt(l.quantity)} {l.unit === "rouleau" ? "pc" : l.unit}{l.pieces && l.unit !== "rouleau" ? ` · ${fmt(l.pieces)} pc` : ""} x {fmtMoney(l.unit_price)}</span><span>{fmtMoney(l.total ?? l.quantity * l.unit_price)}</span></div></div>)}
      </>}
      <p className="my-1 text-center">--------------------------------</p>
      <div className="flex justify-between text-base font-bold"><span>TOTAL ACHAT</span><span data-testid="purchase-receipt-total">{fmtMoney(p.amount)} {settings.currency}</span></div>
      <div className="flex justify-between"><span>Statut</span><span>À payer au fournisseur</span></div>
      <p className="my-1 text-center">--------------------------------</p>
      <p className="mt-2 text-center text-[10px]">{settings.footer}</p>
    </div>
  );
};
